import { adminServices } from "../../Services/AdminServices/admin.services";


const adminListing = async (params) => {
    let response = await adminServices.adminListing(params);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const adminCreate = async () => {
    let post = {
        "name": "Pritpal",
        "phonenumber": "9988777805",
        "email": "pritpal@oxford.com",
        "password": "Globiz#123",
        "role": 3,
        "department": 11,
        "specialization": "Doctor",
        "hospital": [1,2],
        "permissions": [
            {
                "slug": "user", 
                "listing": 1,
                "create": 1,
                "update": 1,
                "delete": 1
            },
            {
                "slug": "hospital", 
                "listing": 1,
                "create": 1,
                "update": 1,
                "delete": 1
            },
            {
                "slug": "department", 
                "listing": 1,
                "create": 0,
                "update": 0,
                "delete": 0
            }
        ]
    }
    let response = await adminServices.adminCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const adminDetail = async (id) => {
    let response = await adminServices.adminDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const adminUpdate = async (id) => {
    let response = await adminServices.adminUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const adminDelete = async (id) => {
    let response = await adminServices.adminDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const adminController = {
    adminListing,
    adminCreate,
    adminDetail,
    adminUpdate,
    adminDelete
};

export default adminController;
